<app-breadcrumb></app-breadcrumb>
<br>
<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
    <div class="col-md-3">
        <div><label for="email" id="groupNameAlert"><b>Choose Period</b> <span class="mandatory-symbol">*</span> :
            </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByPeriodId" (closed)="periodSearchText=''"
            (click)="focusSearch('focus-title-search')" (keydown.enter)="focusSearch('focus-title-search')">
            <input type="search" id="focus-title-search" class="dropdownsearchstyle" [(ngModel)]="periodSearchText"
                matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onPeriodSelectnew($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of periodValueDropdown | assessmentSearch : periodSearchText;"
                (onSelectionChange)="onPeriodSelectnew($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
            </mat-option>
        </mat-select>
    </div>
</div>
<br>
<!--Details grid -->
<div class="row" *ngIf="childGridShow">
    <div class="menu-container">
        <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
                <span class="gridName">Training Review</span>
            </div>
        </div>
    </div>
    <div class="table-container">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-4">
                <div class="action-buttons-container">
                    <div class="addIconContiner" (click)="openAddPopup()" (keydown.enter)="openAddPopup()"
                        matTooltip="Add Users">
                        <i class="fas fa-plus"></i>
                    </div>
                    <div class="reloadIconContiner" (click)="getUserPriod(reviewPeriodId)"
                        (keydown.enter)="getUserPriod(reviewPeriodId)" matTooltip="Refresh Grid">
                        <i class="fas fa-redo-alt"></i>
                    </div>
                </div>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
                (keydown.enter)="openAuditTrail('overAll',0)">
                <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Audit Trail</span>
            </div>
        </div> &nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead style="z-index:9">
                    <th class="sticky-dynamic-col1" style="width:250px">
                        <span>User Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                        <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter('userFullname', $event,'s')" />
                    </th>
                    <th class="sticky-dynamic-col1" style="width:250px">
                        <span>From Date</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                        <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter('fromDate', $event,'d')" />
                    </th>
                    <th class="sticky-dynamic-col1" style="width:250px">
                        <span>To Date</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                        <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter('toDate', $event,'d')" />
                    </th>
                    <th class="sticky-dynamic-col1" style="width:250px">
                        <span>Comments</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                        <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter('comments', $event,'s')" />
                    </th>
                    <th class="sticky-dynamic-col1" style="width:250px">
                        <span>Review Status</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                        <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter('reviewStatus', $event,'s')" />
                    </th>
                    <th class="sticky-dynamic-col1" style="width:250px">
                        <span>Review By</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                        <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter('reviewUser', $event,'s')" />
                    </th>
                    <th class="sticky-dynamic-col1" style="width:250px">
                        <span>Review On</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                        <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter('reviewedOn', $event,'d')" />
                    </th>
                    <th id="menu" class="sticky-dynamic-col1 first-col" style="width:250px"></th>
                </thead>
                <tr *ngFor="let listOfUsersData of pagedItems; let idx = index;">
                    <td class="row-data" style="cursor: pointer;color: blue;"
                        (click)="getUserStatusDetails(listOfUsersData.userId,listOfUsersData.reviewPeriodId)"
                        (keydown.enter)="getUserStatusDetails(listOfUsersData.userId,listOfUsersData.reviewPeriodId)">
                        <U>{{listOfUsersData.userFullname}}</U>
                    </td>
                    <td class="row-data">{{listOfUsersData.fromDateStr}}
                    </td>
                    <td class="row-data">{{listOfUsersData.toDateStr}}
                    </td>
                    <td class="row-data">{{listOfUsersData.comments}}</td>
                    <td class="row-data">{{listOfUsersData.reviewStatus}}</td>
                    <td class="row-data">{{listOfUsersData.reviewUser}}</td>
                    <td class="row-data">{{listOfUsersData.reviewedOnStr}}
                    </td>
                    <td class="sticky-col first-col">
                        <div class="action-icons">
                            <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete" style="margin-left: 0px;"
                                (click)="openDeletePopup(listOfUsersData)"
                                (keydown.enter)="openDeletePopup(listOfUsersData)"></i>
                            <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
                                *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('individual',listOfUsersData)"
                                (keydown.enter)="openAuditTrail('individual',listOfUsersData)"></i>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic4" ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
                        <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>
</div>
<!--Search user grid-->
<ng-template #searchUserPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchManagerFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupData.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
        <div class="row">
            <label style="color:red;" for=" " *ngIf="noUserAlert">Please select user</label>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div><label for="email "><b>User Name</b> </label></div>
                <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
                    [(ngModel)]="searchByUserName">
                <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
            </div>
            <div class="col-md-4">
                <div><label for="email"><b>First Name</b></label></div>
                <input class="search-filed-continers" type="text" placeholder="Enter First Name"
                    [(ngModel)]="searchByFirstName">
                <div id="firstName-val-icon" class="field-icon-container"></div>
            </div>
            <div class="col-md-4">
                <div><label for="email"><b>Last Name</b></label></div>
                <input class="search-filed-continers" type="text" placeholder="Enter Last Name"
                    [(ngModel)]="searchByLastName">
                <div id="lastName-val-icon" class="field-icon-container"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div><label for="email"><b>Designation</b></label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
                    (closed)="designationSearchText=''" (click)="focusSearch('focus-title-search')"
                    (keydown.enter)="focusSearch('focus-title-search')">
                    <input type="search" id="designatio-search" class="dropdownsearchstyle"
                        [(ngModel)]="designationSearchText" matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of designationListDropdown | assessmentSearch : designationSearchText;"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-4">
                <div><label for="email"><b>Department</b></label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
                    (closed)="departmentSearchText=''" (click)="focusSearch('focus-title-search')"
                    (keydown.enter)="focusSearch('focus-title-search')">
                    <input type="search" id="dept-search" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
                        matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of departmentListDropdown | assessmentSearch : departmentSearchText;"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-4">
                <div><label for="email"><b>Manager Name</b></label></div>
                <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
                    [(ngModel)]="searchUserNameForManagerselection" style="width:80%">&nbsp;&nbsp;
                <i (click)="openSearchMangerPopup()" (keydown.enter)="openSearchMangerPopup()"
                    class="fa fa-search fa-1x"></i>
            </div>
        </div>
        <br><br>
        <div class="row" style="margin-top: 4%;">
            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="searchUser()">
                    <i class="fa-solid fa-magnifying-glass"></i> Search
                </button>
                <button mat-stroked-button class="cancelButton" (click)="resetSearchManagerGridDataFunction()">
                    <i class="fa fa-repeat"></i> Reset
                </button>
            </div>
        </div>
        <div class="table-container" *ngIf="showUserSearchGrid">
            <table class="dynamic-table-container" style="height: 50vh;">
                <thead>
                    <th style="min-width: 80px; text-align: center;">
                        <div style="display: flex; justify-content: center; align-items: center;">
                            <input id="selectAllUsersCheckbox" type="checkbox" style="zoom: 1.2;"
                                (change)="selectAllUsersChanged($event)">
                        </div>
                    </th>
                    <th>
                        <span>User Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>First Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Last Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>User Full Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Designation</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Department</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>EmailAddress</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Contact Number</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Manager Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Is Ad User</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Is Factory User</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th class="sticky-col first-col menu"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container"
                        *ngFor="let listOfUsersData of getOneQmsUsersVwDetails; let idx = index;">
                        <td style="min-width: 80px; text-align: center;">
                            <div style="display: flex;">
                                <div
                                    [ngClass]="listOfUsersData.searchUserChildCheckBox ? 'static_icon' : 'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div style="margin-left: 5px;">
                                    <input id="selectedUserCheckBox_{{ idx }}" type="checkbox" style="zoom: 1.2;"
                                        [checked]="listOfUsersData.searchUserChildCheckBox"
                                        (change)="onChildCheckBoxChanged($event, listOfUsersData, idx)">
                                </div>
                            </div>
                        </td>
                        <td class="row-data">{{ listOfUsersData.userName }}</td>
                        <td class="row-data">{{ listOfUsersData.firstName }}</td>
                        <td class="row-data">{{ listOfUsersData.lastName }}</td>
                        <td class="row-data">{{ listOfUsersData.userFullName }}</td>
                        <td class="row-data">{{ listOfUsersData.designation }}</td>
                        <td class="row-data">{{ listOfUsersData.department }}</td>
                        <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
                        <td class="row-data">{{ listOfUsersData.contactNumber }}</td>
                        <td class="row-data">{{ listOfUsersData.managerName }}</td>
                        <td class="row-data" style="text-align: center; zoom: 1.2;"> <input
                                class="activeCheckbox-container" type="checkbox" [(ngModel)]="listOfUsersData.isAdUser">
                        </td>
                        <td class="row-data" style="text-align: center; zoom: 1.2;"> <input
                                class="activeCheckbox-container" type="checkbox"
                                [(ngModel)]="listOfUsersData.isFactoryUser"> </td>
                        <td class="row-data" style="text-align: center; zoom: 1.2;"> <input
                                class="activeCheckbox-container" type="checkbox" [(ngModel)]="listOfUsersData.isActive">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
        <button mat-stroked-button class="addButton" (click)="setUser()">
            <i class="fas fa-check"></i> Add
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>
<!--Search Manager grid-->
<ng-template #searchManagerPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchManagerForManagerselectionFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupData.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer filed-container">
        <div class="row">
            <label style="color:red;" for=" " *ngIf="noUserAlert">Please select user</label>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div><label for="email ">User Name</label></div>
                <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
                    [(ngModel)]="searchByUserNameForManagerselection">
                <div id="searchbyUserName-icon" class="field-icon-container"></div>
            </div>
            <div class="col-md-4">
                <div><label for="email">First Name</label></div>
                <input class="search-filed-continers" type="text" placeholder="Enter First Name"
                    [(ngModel)]="searchByFirstNameForManagerselection">
                <div id="firstName-icon" class="field-icon-container"></div>
            </div>
            <div class="col-md-4">
                <div><label for="email">Last Name</label></div>
                <input class="search-filed-continers" type="text" placeholder="Enter Last Name"
                    [(ngModel)]="searchByLastNameForManagerselection">
                <div id="lastName-icon" class="field-icon-container"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div><label for="email">Designation</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCodeForManagerselection"
                    (closed)="designationSearchText=''" (click)="focusSearch('focus-title-search')"
                    (keydown.enter)="focusSearch('focus-title-search')">
                    <input type="search" id="designation-search" class="dropdownsearchstyle"
                        [(ngModel)]="designationSearchText" matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option
                        *ngFor="let item of designationListDropdownForManagerselection | assessmentSearch : designationSearchText;"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-4">
                <div><label for="email">Department</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCodeForManagerselection"
                    (closed)="departmentSearchText=''" (click)="focusSearch('focus-title-search')"
                    (keydown.enter)="focusSearch('focus-title-search')">
                    <input type="search" id="deptartment-search" class="dropdownsearchstyle"
                        [(ngModel)]="departmentSearchText" matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option
                        *ngFor="let item of departmentListDropdownForManagerselection | assessmentSearch : departmentSearchText;"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="row" style="margin-top: 4%;">
            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="searchUserForManagerselection()">
                    <i class="fa-solid fa-magnifying-glass"></i> Search
                </button>
                <button mat-stroked-button class="cancelButton"
                    (click)="resetSearchManagerGridDataForManagerselectionFunction()">
                    <i class="fa fa-repeat"></i> Reset
                </button>
            </div>
        </div>
        <div class="table-container" *ngIf="showUserSearchGridForManagerselection">
            <table class="dynamic-table-container" style="height: 50vh;">
                <thead>
                    <th style="min-width: 80px; text-align: center;">
                        <div style="display: flex;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                        </div>
                    </th>
                    <th>
                        <span>User Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>First Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Last Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>User Full Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Designation</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Department</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>EmailAddress</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Contact Number</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Manager Name</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Is Ad User</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Is Factory User</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter multi-filter-container"></span>
                    </th>
                    <th class="sticky-col first-col menu"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container"
                        *ngFor="let listOfUsersData of getOneQmsUsersVwDetailsForManagerselection; let idx = index;">
                        <td style="min-width: 80px; text-align: center;">
                            <div style="display: flex;">
                                <div
                                    [ngClass]="listOfUsersData.searchUserChildCheckBox ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div style="margin-left: 5px;">
                                    <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                                        [checked]="listOfUsersData.searchUserChildCheckBox"
                                        (change)="onChildCheckBoxChangedForManagerselection($event, listOfUsersData, idx)">
                                </div>
                            </div>
                        </td>
                        <td class="row-data">{{ listOfUsersData.userName }}</td>
                        <td class="row-data">{{ listOfUsersData.firstName }}</td>
                        <td class="row-data">{{ listOfUsersData.lastName }}</td>
                        <td class="row-data">{{ listOfUsersData.userFullName }}</td>
                        <td class="row-data">{{ listOfUsersData.designation }}</td>
                        <td class="row-data">{{ listOfUsersData.department }}</td>
                        <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
                        <td class="row-data">{{ listOfUsersData.contactNumber }}</td>
                        <td class="row-data">{{ listOfUsersData.managerName }}</td>
                        <td class="row-data" style="text-align: center; zoom: 1.2;"> <input
                                class="activeCheckbox-container" type="checkbox" [(ngModel)]="listOfUsersData.isAdUser">
                        </td>
                        <td class="row-data" style="text-align: center; zoom: 1.2;"> <input
                                class="activeCheckbox-container" type="checkbox"
                                [(ngModel)]="listOfUsersData.isFactoryUser"> </td>
                        <td class="row-data" style="text-align: center; zoom: 1.2;"> <input
                                class="activeCheckbox-container" type="checkbox" [(ngModel)]="listOfUsersData.isActive">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
        <button mat-stroked-button class="addButton" (click)="setUserForManagerselection()">
            <i class="fas fa-check"></i> Add
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerForManagerselectionFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>
<!--Search User Popup-->
<ng-template #addUserPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddUserPopupFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle">Add User(s)</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer filed-container" style="height: min-content;">
        <div class="row">
            <label style="color:red;" for=" " *ngIf="noUserAlert">Please select user</label>
        </div>
        <div class="row">
            <div class="col-md-3">
                <label for="email"><b>From Date</b> <span class="mandatory-symbol">*</span> : </label>
                <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
                    [disabled]="isFixedPeriod" [bsConfig]="datePickerConfiguration"
                    [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
            </div>
            <div class="col-md-3">
                <label for="email"><b>To Date</b> <span class="mandatory-symbol">*</span>: </label>
                <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
                    [disabled]="isFixedPeriod" [bsConfig]="datePickerConfiguration"
                    [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
            </div>
            <div class="col-md-4">
                <div>
                    <label for="email" id="userNameAlert"><b>User Name</b> <span class="mandatory-symbol">*</span> :
                    </label>
                </div>
                <input id="participantUserName" style="cursor: not-allowed;" type="text" class="userNametextbox"
                    [(ngModel)]="searchUserName" disabled> &nbsp;&nbsp;
                <i *ngIf="searchByPeriodId!=null" (click)="openSearchUserPopup('ToUser')"
                    (keydown.enter)="openSearchUserPopup('ToUser')" class="fa fa-search fa-1x"></i>
            </div>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
        <button mat-stroked-button class="addButton" (click)="getUsersDetails()">
            <i class="fas fa-check"></i> Add
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelAddUserPopupFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>
<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle">Delete User</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div>
            <div class="row">
                <div class="col-md-12">
                    <div><label for="email">Reason for Delete</label><span class="mandatory-symbol">*</span></div>
                    <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
                        [(ngModel)]="getUserPriodDataForDelete.deleteReason"></textarea>
                </div>
            </div>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
                <i class="fa fa-trash"></i> Delete
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
    <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
        <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="align-center">
        <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title
            }}
            ?</label>
    </div>
    <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
        <label for="email" style="font-size: .7rem; font-weight: bold;">
            <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
            <span *ngIf="manuallyPicked && maxCountReached">
                We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
            </span>
        </label>
    </div>
    <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
        <div class="col-md-12" *ngIf="selectedColumns.length">
            <div><label for="email">Selected Column(s)</label></div>
            <textarea id="selectedValuesTextarea" class="input-filed-textarea"
                style="margin-top: 8px; cursor: not-allowed;" rows="4" cols="50" [disabled]="true"
                [(ngModel)]="selectedColumnsAsString"></textarea>
        </div>
        <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
            <div class="col-md-6">
                <label for="radio">PDF Page Size</label>
                <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
                    <mat-radio-button *ngFor="let data of pdfPageSizes"
                        [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-md-6" style="margin-top: 1.5%;">
                <label for="toggle">Pick Columns Manually?</label>&nbsp;
                <mat-slide-toggle color="primary" (change)="onCheckboxChange1($event)" [(ngModel)]="manuallyPicked"
                    id="toggle">
                    <ng-container *ngIf="manuallyPicked; else no">
                        <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #no>
                        <span style="color: red;">No</span>
                    </ng-template>
                </mat-slide-toggle>
            </div>
        </div>
        <div class="row mt-3" *ngIf="manuallyPicked">
            <div class="col-md-12">
                <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
                <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
                    (closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')"
                    (keydown.enter)="focusSearch('focus-department-search')">
                    <input type="search" id="focus-department-search" class="dropdownsearchstyle"
                        [(ngModel)]="pdfSearchText" matInput placeholder="search">
                    <div class="select-all">
                        <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select
                            All</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>

        <div class="row justify-content-md-center">
            <div class="col-sm-4">
                <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
            </div>
            <div class="col-sm-8">
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
                    (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
                    (keydown.enter)="focusSearch('focus-Logo-search')">
                    <input type="search" id="focus-footer-search" class="dropdownsearchstyle"
                        [(ngModel)]="pdfDetailSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle"
                        (onSelectionChange)="onReportFooterSelect($event,null);">Un-select</mat-option>
                    <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                        (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
    </div>
    <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
        <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
            <i class="fa fa-file-excel-o"></i> Generate
        </button>
        <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
            <i class="fa fa-file-pdf-o"></i> Generate
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>